import { Validator, errorMessages } from 'services/validator'
import { LOGIN_PROPERTY } from './constants'

export default Validator.combineValidators({
  [LOGIN_PROPERTY]: [
    {
      validators: Validator.required(),
      errorMessage: errorMessages.EMAIL_EMPTY_MESSAGE
    },
    {
      validators: Validator.email(),
      errorMessage: errorMessages.REGISTERED_EMAIL_ERROR_MESSAGE
    }
  ]
})
